import 'react-responsive-carousel/lib/styles/carousel.min.css';

